/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  DeleteLogoMutationRequest,
  DeleteLogoMutationResponse,
} from "../types/DeleteLogo.ts"

export const deleteLogoMutationKey = () =>
  [{ url: "/v1/organization-settings/delete-logo" }] as const

export type DeleteLogoMutationKey = ReturnType<typeof deleteLogoMutationKey>

/**
 * @summary Delete a logo
 * {@link /v1/organization-settings/delete-logo}
 */
export async function deleteLogo(
  data: DeleteLogoMutationRequest,
  config: Partial<RequestConfig<DeleteLogoMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    DeleteLogoMutationResponse,
    ResponseErrorConfig<Error>,
    DeleteLogoMutationRequest
  >({
    method: "DELETE",
    url: `/v1/organization-settings/delete-logo`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function deleteLogoMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<DeleteLogoMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = deleteLogoMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteLogoMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteLogoMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return deleteLogo(data, config)
    },
  })
}

/**
 * @summary Delete a logo
 * {@link /v1/organization-settings/delete-logo}
 */
export function useDeleteLogo<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteLogoMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: DeleteLogoMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<DeleteLogoMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? deleteLogoMutationKey()

  const baseOptions = deleteLogoMutationOptions(config) as UseMutationOptions<
    ResponseConfig<DeleteLogoMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteLogoMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteLogoMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteLogoMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteLogoMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteLogoMutationRequest },
    TContext
  >
}
